import '@mdi/font/css/materialdesignicons.css'; // Ensure you are using css-loader
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import VueI18n from 'vue-i18n';

import en_vuetify from 'vuetify/es5/locale/en';
import es_vuetify from 'vuetify/es5/locale/es';
import fr_vuetify from 'vuetify/es5/locale/fr';
import pt_vuetify from 'vuetify/es5/locale/pt';
import it_vuetify from 'vuetify/es5/locale/it';

var vuetifyOptions = {
	icons: {
		iconfont: 'mdi',
	},
	theme: {
		themes: {
			light: {
				primary: '#01579B',
				secondary: '#F65447',
				accent: '#8c9eff',
				error: '#b71c1c',
			},
		},
	},
	lang: {
		locales: { en_vuetify, es_vuetify, fr_vuetify, pt_vuetify, it_vuetify },
		current: 'it',
		silentFallbackWarn: true,
		t: (key, ...params) => i18n.t(key, params),
	},
};

import it from '../i18n/it.ts';
import en from '../i18n/en.ts';
Vue.use(Vuetify);
Vue.use(VueI18n);
const messages = {
	it: {
		$vuetify: it,
	},
	en: {
		$vuetify: en,
	},
};
const i18n = new VueI18n({
	locale: 'it', // set locale
	messages, // set locale messages
	silentTranslationWarn: true,
});

export default new Vuetify(vuetifyOptions);
